<template>
  <div class="container mx-auto px-4 py-6">
    <!-- Self Perform Section -->
    <div
      v-if="!projectsStore.project?.isClient"
      class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mt-8"
    >
      <div class="bg-gradient-to-r from-ccm-blue-100 to-ccm-blue-200 px-4 py-3">
        <div class="flex items-center justify-between">
          <h2 class="font-semibold text-white text-lg">
            {{ $t('Mobile.MobileProjectPage.selfPerform') }}
          </h2>

          <div class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-white">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
</svg>
          </div>
        </div>
      </div>

      <div class="p-4 space-y-3">
        <div class="text-center underline text-sm flex items-center justify-center space-x-2">
          <span>
            {{ $t('Mobile.MobileProjectPage.cantFindLookingFor') }}
          </span>

          <AppInfoHover :tooltip="$t('Mobile.MobileProjectPage.desktopInterfaceTooltip')" />
        </div>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileLabourDashboard')"
          :to="{ name: 'MobileLabourDashboard', query: { day: date } }"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
          data-test="new-labour"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-white">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.addNewLabourRecord') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobilePlantDashboard')"
          :to="{ name: 'MobilePlantDashboard', query: { day: date } }"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
          data-test="new-plant"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.87171 1.58811C4.18324 1.9184 4.34293 2.75714 4.79289 3.20711L9.08579 7.5L7.5 9.08579L3.20711 4.79289C2.75711 4.3429 1.90944 4.19971 1.58419 4.87995C0.985604 6.1319 0.769329 7.54124 0.975579 8.9287C1.23113 10.6478 2.11708 12.2104 3.46105 13.3124C4.80502 14.4144 6.51089 14.977 8.24676 14.8908C8.89048 14.8588 9.52124 14.7385 10.1228 14.537L17.8787 22.2929C19.0503 23.4645 20.9497 23.4645 22.1213 22.2929L22.2929 22.1213C23.4645 20.9497 23.4645 19.0503 22.2929 17.8787L14.537 10.1228C14.7395 9.51835 14.8601 8.8844 14.8913 8.2375C14.9753 6.50151 14.4104 4.79638 13.3066 3.45387C12.2028 2.11135 10.6391 1.22746 8.91964 0.974169C7.53192 0.769745 6.12286 0.987876 4.87171 1.58811ZM12.0945 10.5087C12.5356 9.7995 12.793 8.98448 12.834 8.13802C12.8932 6.91285 12.4946 5.70946 11.7156 4.76198C10.9366 3.8145 9.83297 3.19069 8.61946 3.01193C8.21216 2.95193 7.80225 2.94351 7.39883 2.98462L10.5 6.08579C11.2811 6.86684 11.281 8.13317 10.5 8.91421L8.91421 10.5C8.13317 11.281 6.86684 11.281 6.08579 10.5L2.98467 7.39888C2.94336 7.8044 2.95209 8.21647 3.01295 8.62584C3.1933 9.8391 3.81856 10.9419 4.76707 11.7196C5.71557 12.4974 6.91949 12.8944 8.14458 12.8336C8.98967 12.7916 9.80314 12.5338 10.511 12.093L11.9946 13.5766L11.9924 13.5782L19.2929 20.8787C19.6834 21.2692 20.3166 21.2692 20.7071 20.8787L20.8787 20.7071C21.2692 20.3166 21.2692 19.6834 20.8787 19.2929L12.0945 10.5087Z" fill="currentColor"/>
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.addNewPlantRecord') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileQuantities')"
          :to="{ name: 'MobileQuantities'}"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-white">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.quantities') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileDashboard')"
          :to="{ name: 'MobileDashboard'}"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-5 h-5 text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.productionData') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileDiaryIndex')"
          :to="{ name: 'MobileDiaryIndex' }"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-white">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.diaryEntry') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileContractEventsIndex')"
          :to="{ name: 'MobileContractEventsIndex' }"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-5 h-5 text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.contractEvents') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>
      </div>
    </div>

    <!-- Head Contract Section -->
    <div
      v-if="hasAccessToHeadContract"
      class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mt-8"
    >
      <div class="bg-gradient-to-r from-ccm-blue-100 to-ccm-blue-200 px-4 py-3">
        <div class="flex items-center justify-between">
          <h2 class="font-semibold text-white text-lg">
            {{ $t('Mobile.MobileProjectPage.headContract') }}
          </h2>

          <div class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-5 h-5 text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>
          </div>
        </div>
      </div>

      <div class="p-4 space-y-3">
        <div
          v-if="projectsStore.project?.isClient"
          class="text-center underline text-sm flex items-center justify-center space-x-2"
        >
          <span>
            {{ $t('Mobile.MobileProjectPage.cantFindLookingFor') }}
          </span>

          <AppInfoHover :tooltip="$t('Mobile.MobileProjectPage.desktopInterfaceTooltip')" />
        </div>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileHeadContractDashboard')"
          :to="{ name: 'MobileHeadContractDashboard' }"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-5 h-5 text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.headContractSummary') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>

        <RouterLink
          v-if="userStore.hasAccessToRoute('MobileContractEventsIndex')"
          :to="{ name: 'MobileContractEventsIndex' }"
          class="group flex items-center justify-between w-full p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
        >
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-5 h-5 text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>
            </div>

            <span class="font-medium text-gray-900">{{ $t('Mobile.MobileProjectPage.contractEvents') }}</span>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useNavStore } from '@/store/nav';
import { useProjectsStore } from '@/store/projects';
import { useUserStore } from '@/store/user';
import { computed } from 'vue';

const date = new Date().toISOString().split('T')[0];
const navStore = useNavStore();
const projectsStore = useProjectsStore();

navStore.backRoute = { name: 'MobileProjectList' };

const userStore = useUserStore();

const hasAccessToHeadContract = computed(() => {
  return userStore.hasAccessToRoute('MobileHeadContractDashboard') ||
    userStore.hasAccessToRoute('MobileContractEventsIndex');
});
</script>
